import * as ActionTypes from 'src/constants/ActionTypes';
import { IDoctorInfo } from 'src/entity/DoctorEntity';
import { IStateSelectDoctor } from 'src/entity/StateEntity';

export function selectDoctor(doctorInfo: IDoctorInfo,  detailType: ActionTypes.DOCTOR_DETAIL_SOURCE): IStateSelectDoctor {
  return {
    type: ActionTypes.DOCTOR_SELECT,
    detailType,
    doctorInfo,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/selectDoctorCreator.ts